/**
 * StatusBanner - Shows service issues in admin area and customer portal
 */
import React, { useState, useEffect } from 'react';
import { AlertTriangle, X, RefreshCw } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const StatusBanner = ({ variant = 'admin' }) => {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const r = await axios.get(`${API}/health/status-banner`, { timeout: 5000 });
        setData(r.data);
      } catch {
        // Silently fail — don't show banner if health endpoint is down
      }
    };
    check();
    const iv = setInterval(check, 60_000);
    return () => clearInterval(iv);
  }, []);

  if (!data?.has_issues || dismissed) return null;

  const isAdmin = variant === 'admin';

  return (
    <div
      className={`px-4 py-2 flex items-center justify-between text-sm ${
        isAdmin
          ? 'bg-red-600 text-white'
          : 'bg-amber-50 border-b border-amber-200 text-amber-800'
      }`}
      data-testid="status-banner"
    >
      <div className="flex items-center gap-2">
        <AlertTriangle className={`h-4 w-4 shrink-0 ${isAdmin ? 'text-white' : 'text-amber-500'}`} />
        <span>
          {isAdmin ? (
            <>
              <strong>System-Alert:</strong>{' '}
              {data.issues.map(i => i.label).join(', ')}{' '}
              {data.issues.length === 1 ? 'ist' : 'sind'} nicht erreichbar
            </>
          ) : (
            <>Einige Funktionen sind momentan eingeschraenkt. Wir arbeiten daran.</>
          )}
        </span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className={`p-1 rounded hover:bg-black/10 ${isAdmin ? 'text-white/80' : 'text-amber-600'}`}
        data-testid="status-banner-dismiss"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

export default StatusBanner;
